import React from "react";

function ArrowInclinedSvg(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || 14}
      height={props.height || 14}
      fill="none"
      viewBox="0 0 15 14"
    >
      <path
        fill={props.fill || "#FF752C"}
        d="M5.115 3.599a.219.219 0 00.219.218h5.04L3.942 10.25a.219.219 0 00.31.31l6.431-6.433v5.04a.219.219 0 00.438 0V3.6a.219.219 0 00-.219-.22H5.334a.219.219 0 00-.219.22z"
      ></path>
    </svg>
  );
}

export default ArrowInclinedSvg;
